import { render, staticRenderFns } from "./Sociais.vue?vue&type=template&id=b2858348"
import script from "./Sociais.vue?vue&type=script&lang=js"
export * from "./Sociais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports